export default __webpack_public_path__ + "static/media/gallery_14.9ceee01f.jpg";